"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CustomToolTip_1 = __importDefault(require("@/components/interactions/CustomToolTip"));
const material_1 = require("@mui/material");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const SectionTitle = ({ title, children, tooltip }) => {
    return (react_1.default.createElement(SectionTitleContainer, null,
        react_1.default.createElement(SectionTitleh2, null,
            react_1.default.createElement(material_1.Box, { sx: { display: 'inline', width: 'fit-content', marginRight: '15px' } },
                title,
                children),
            tooltip && react_1.default.createElement(CustomToolTip_1.default, { description: tooltip })),
        react_1.default.createElement(SectionTitleFilet, null)));
};
exports.default = SectionTitle;
const SectionTitleContainer = (0, styled_components_1.default)('div') `
  grid-column: span 12;
  width: 100%;
  display: flex;
  align-items: center;
  ${(props) => props.theme.media.md} {
  }
  ${(props) => props.theme.media.sm} {
  }
  ${(props) => props.theme.media.xs} {
  }
`;
const SectionTitleFilet = (0, styled_components_1.default)('div') `
  background-color: ${(props) => props.theme.colors.sectionTitle.bg};
  flex-grow: 1;
  height: 2px;
`;
const SectionTitleh2 = (0, styled_components_1.default)('h2') `
  background-color: ${(props) => props.theme.colors.sectionTitle.bg};
  color: ${(props) => props.theme.colors.sectionTitle.onBg};
  border-radius: ${(props) => props.theme.radius.md};
  font-size: 0.85em;
  text-transform: capitalize;
  padding: 10px 20px;
  font-weight: 600;
`;
